<template>
  <div class="page">
    <wk-search
      class="wrapBox"
      :search-control-data="searchControlData"
      @search="search($event)"
    ></wk-search>
    <div class="wrapBox">
      <div class="flex justify-space-between" style="margin-bottom: 10px">
        <div style="line-height: 40px">共{{total}}项活动</div>
        <el-button class="common-button" v-auth="permission.ALLIANCE_ACTIVITY_ADD"   type="primary" @click="add()">
          添加联盟活动
        </el-button>
      </div>
      <el-table
        v-auth="permission.ACTIVITY_ENROLL_LIST"
        class="tableBox"
        :data="tableData"
        stripe
        style="width: 100%">
        <el-table-column
          align="center"
          type="index"
          label="序号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="活动"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          align="center"
          prop="id"
          label="id">
        </el-table-column>
        <el-table-column
          align="center"
          prop="activityLink"
          label="活动链接">
          <template slot-scope="scope">
            <a :href="`${VUE_APP_WEB_URL}/activity?id=${scope.row.id}`" target="_blank">
              {{`${VUE_APP_WEB_URL}/activity?id=${scope.row.id}`}}
            </a>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="onlineTime"
          label="上线时间">
          <template slot-scope="scope">
            <span>{{ scope.row.onlineTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="registrationStartTime"
          label="报名时间">
          <template slot-scope="scope">
            <span>{{ scope.row.registrationStartTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="registrationEndTime"
          label="报名截止时间">
          <template slot-scope="scope">
            <span>{{ scope.row.registrationEndTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="offlineTime"
          label="下线时间">
          <template slot-scope="scope">
            <span>{{ scope.row.offlineTime | parseTime() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="status"
          label="状态">
          <template slot-scope="scope">
            <span>{{ scope.row.status == 1 ? '开启' : '关闭' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-link v-auth="permission.ACTIVITY_ENROLL_EDIT"  @click="edit(scope.row.id)">
              编辑
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="text-right margin-t30">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50]"
          :page-size="searchFormData.perPage"
          :current-page="searchFormData.page"
          layout="total, prev, pager, next, sizes"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <router-view/>
  </div>
</template>
<script>
  import store from '@/store/index.js';
  export default {
    beforeRouteEnter: (to,from,next) => {
      store.commit("breadcrumbStore/setMenuBreadcrumb", {'menu': to.meta.menuBreadcrumb, name: "活动报名管理", path: to.fullPath} );
      next()
    },
    data() {
      return {
        VUE_APP_WEB_URL: process.env.VUE_APP_WEB_URL,
        total: 0,
        dialogVisible: false,
        loading: false,
        searchFormData: {
          page: 1,
          perPage: 10,
        },
        searchControlData: [
          {
            type: 'select',
            label: '状态',
            placeholder: '请选择状态',
            key: 'status',
            option: [
              {
                label: '全部',
                value: ''
              },
              {
                label: '开启',
                value: '1'
              },
              {
                label: '关闭',
                value: '2'
              },
            ]
          },
          {
            type: 'input',
            label: '活动名称',
            placeholder: '请输入活动名称',
            key: 'name'
          },
        ],
        tableData: []
      }
    },
    watch: {
      '$route.query.date' () {
        window.location.reload();
      },
    },
    created() {
      this.search()
    },
    methods: {
      search(data) {
        this.loading = true
        if (data) {
          Object.assign(this.searchFormData, data)
          this.searchFormData.page = 1
        }
        this.$apis.activityEnrollServer.queryList(this.searchFormData).then(res => {
          if (res['code'] == 0 && res.data.data) {
            this.total = res.data.total
            this.tableData = res.data.data
          } else {
            this.total = 0
            this.tableData = []
          }
          this.loading = false
        })
      },
      add(){
        this.$router.push({
          path:'/activityEnroll/info',
          query:{}
        })
      },
      edit(id) {
       this.$router.push({
         path:'/activityEnroll/info',
         query:{
          id: id
         }
       })
      },
      handleSizeChange(val) {
        this.searchFormData.perPage = val
        this.search()
      },
      handleCurrentChange(val) {
        this.searchFormData.page = val
        this.search()
      }
    }
  }
</script>

<style scoped lang="scss">
</style>